/** @format */

import { createAction, props } from '@ngrx/store';

import { SocialContentItems } from '../../model';

/**
 * Action types initialization
 */
export enum SocialContentActionTypes {
	CLOSE_SOCIAL_CONTENT_MODAL = '[Social Content] Close Modal',
	OPEN_SOCIAL_CONTENT_MODAL = '[Social Content] Open Modal',
	SET_SOCIAL_CONTENT_CAROUSEL_INDEX = '[Social Content] Set Carousel Index',
	SET_SOCIAL_CONTENT_STATE = '[Social Content] Set Social Content State'
}

/**
 * Actions initialization
 */
export const setProductSocialContentState = createAction(
	SocialContentActionTypes.SET_SOCIAL_CONTENT_STATE,
	props<{
		items: SocialContentItems[];
		resultsCount: number;
	}>()
);

export const openSocialContentModal = createAction(
	SocialContentActionTypes.OPEN_SOCIAL_CONTENT_MODAL
);

export const closeSocialContentModal = createAction(
	SocialContentActionTypes.CLOSE_SOCIAL_CONTENT_MODAL
);

export const setSocialContentCarouselIndex = createAction(
	SocialContentActionTypes.SET_SOCIAL_CONTENT_CAROUSEL_INDEX,
	props<{
		index: number;
	}>()
);
